import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 mt-auto w-full overflow-hidden" data-id="element-388">
      <div className="px-4 py-6" data-id="element-389">
        <div className="flex flex-col items-center gap-4 text-center" data-id="element-390">
          <div className="flex items-center gap-2" data-id="element-391">
            <img src="https://i.imgur.com/bxPZvDb.png" alt="Cricket Logo" className="h-8 w-auto object-contain" data-id="element-392" />
          </div>

          <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-393">
            © {new Date().getFullYear()} Cricket. Todos los derechos
            reservados.
          </p>

          <div className="flex gap-4 text-sm text-gray-600 dark:text-gray-400" data-id="element-394">
            <Link to="/terms" className="hover:text-gray-900 dark:hover:text-white transition-colors" data-id="element-395">
              Términos
            </Link>
            <Link to="/privacy" className="hover:text-gray-900 dark:hover:text-white transition-colors" data-id="element-396">
              Privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}